import { TEST_TEMPLATES_COMPARISON_TO_LABEL, TEST_TEMPLATE_RESULT_UOM_OPTIONS } from "./constants"
import type { TestTemplateFormValues } from "./types"

import type { TestTemplateComparison, TestTemplateCreateInput } from "@/graphql/codegen/graphql"
import { toStringOrNull } from "@/utils/forms"

export const getTestTemplateComparisonLabel = (comparison: TestTemplateComparison | string): string =>
  TEST_TEMPLATES_COMPARISON_TO_LABEL.get(comparison) ?? comparison

export const getTestTemplateResultUomLabel = (value: string | null | undefined): string => {
  if (!value) return ""

  const option = TEST_TEMPLATE_RESULT_UOM_OPTIONS.find((opt) => opt.value === value)

  return option?.label ?? value
}

export const serializeTestTemplateForm = (formValues: TestTemplateFormValues): TestTemplateCreateInput => {
  return {
    description: formValues.description,
    comparison: formValues.comparison as TestTemplateComparison,
    resultsUnitOfMeasure: toStringOrNull(formValues.resultsUnitOfMeasure),
  }
}
